// Layer 3 (Transformation): glass-poc-run A3 / #448 — Paul's recovery
// performance table slot, our numbers. Actual from the engine for the
// period; target/design from the existing `Reading.target`/`.design`
// fields (decisions.md 15:50 — the grounded seed, not Paul's typed 75.0/
// 72.3/72.0 · 88.2/85.1/84.2). Pure — no React.

import {
  recoveryActualPct,
  recoveryDesignPct,
  recoveryTargetPct,
  type PeriodView,
} from '@/versions/v1/modules/ingestion/MetalAccountingLayer.transform';
import type { VizTone } from '@/versions/v1/modules/_viz';

export type RecoveryPerformanceRow = {
  id: string;
  element: 'Pb' | 'Zn' | 'Ag';
  actual: string;
  target: string;
  design: string;
  variance: string;
  tone: VizTone;
};

export function recoveryPerformanceRows(view: PeriodView): readonly RecoveryPerformanceRow[] {
  return (['Pb', 'Zn', 'Ag'] as const).map((element) => {
    const actual = recoveryActualPct(element, view);
    const target = recoveryTargetPct(element);
    const design = recoveryDesignPct(element);
    const variance = actual !== null && target !== null ? actual - target : null;
    const tone: VizTone = variance === null ? 'neutral' : variance >= 0 ? 'ok' : 'bad';
    return {
      id: `rp-${element.toLowerCase()}`,
      element,
      actual: actual !== null ? `${actual.toFixed(1)}%` : '—',
      target: target !== null ? `${target.toFixed(1)}%` : '—',
      design: design !== null ? `${design.toFixed(1)}%` : '—',
      variance: variance !== null ? `${variance >= 0 ? '+' : ''}${variance.toFixed(1)} pt` : '—',
      tone,
    };
  });
}
